// import pacchetti
import { useState } from "react";

// import styles
import "./Project.css";

export default function ProjectEditForm({ prj, onSave, onCancel }) {
  const [nome, setNome] = useState(prj.nome);
  const [dettagli, setDettagli] = useState(prj.dettagli);
  const [scadenza, setScadenza] = useState(() => {
    if (!prj.scadenza) return "";
    try {
      // Verifica se scadenza è un oggetto Timestamp di Firestore
      if (prj.scadenza.toDate && typeof prj.scadenza.toDate === 'function') {
        return prj.scadenza.toDate().toISOString().split("T")[0];
      } 
      // Se è già una stringa in formato data (YYYY-MM-DD)
      else if (typeof prj.scadenza === 'string' && prj.scadenza.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return prj.scadenza;
      }
      // Se è una data JavaScript
      else if (prj.scadenza instanceof Date) {
        return prj.scadenza.toISOString().split("T")[0];
      }
      // Fallback
      return "";
    } catch (error) {
      console.error("Errore nella conversione della data:", error);
      return "";
    }
  });
  const [codice, setCodice] = useState(prj.codice || "");
  const [cliente, setCliente] = useState(prj.cliente || "");
  const [localizzazione, setLocalizzazione] = useState(prj.localizzazione || "");
  const [preventivo, setPreventivo] = useState(prj.preventivo || "");
  const [formError, setFormError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError(null);

    const projectData = {
      nome,
      dettagli,
      codice,
      cliente,
      localizzazione,
      preventivo: preventivo ? parseFloat(preventivo) : 0,
    };

    if (prj.tipoProject === "cantiere") {
      projectData.scadenza = scadenza;
    }

    onSave(projectData);
  };

  return (
    <div className="edit-project-form">
      <h2>Modifica Dati {prj.tipoProject === "cantiere" ? "Cantiere" : prj.tipoProject === "commessa" ? "Commessa" : "Centro di Costo"}</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <span>Nome {prj.tipoProject === "cantiere" ? "Cantiere" : prj.tipoProject === "commessa" ? "Commessa" : "Centro di Costo"}:</span>
          <input
            type="text"
            required
            onChange={(e) => setNome(e.target.value)}
            value={nome}
          />
        </label>
        <label>
          <span>Dettagli:</span>
          <textarea
            onChange={(e) => setDettagli(e.target.value)}
            value={dettagli}
          ></textarea>
        </label>
        {prj.tipoProject === "cantiere" ? (
          <label>
            <span>Data di Scadenza:</span>
            <input
              type="date"
              required
              onChange={(e) => setScadenza(e.target.value)}
              value={scadenza}
            />
          </label>
        ) : null}
        <label>
          <span>Codice {prj.tipoProject === "cantiere" ? "Cantiere" : prj.tipoProject === "commessa" ? "Commessa" : "Centro di Costo"}:</span>
          <input
            type="text"
            onChange={(e) => setCodice(e.target.value)}
            value={codice}
          />
        </label>
        {prj.tipoProject !== "centro-di-costo" && (
          <>
            <label>
              <span>Cliente:</span>
              <input
                type="text"
                onChange={(e) => setCliente(e.target.value)}
                value={cliente}
              />
            </label>
            <label>
              <span>Localizzazione:</span>
              <input
                type="text"
                onChange={(e) => setLocalizzazione(e.target.value)}
                value={localizzazione}
              />
            </label>
          </>
        )}
        {prj.tipoProject === "cantiere" && (
          <label>
            <span>Preventivo (€):</span>
            <input
              type="number"
              step="0.01"
              min="0"
              onChange={(e) => setPreventivo(e.target.value)}
              value={preventivo}
            />
          </label>
        )}
        <div className="edit-buttons">
          <button className="btn">Salva Modifiche</button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
          >
            Annulla
          </button>
        </div>
        {formError && <p className="error">{formError}</p>}
      </form>
    </div>
  );
}